import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const scrollToProducts = (e) => {
    e.preventDefault();
    document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="vts-footer">
      <div className="footer-inner container">
        <div className="f-brand">
          <div className="f-logo-row">
            <img src="/logo.png" alt="Vision Techno Services" className="f-logo" />
            <span className="f-brand-name">Vision Techno Services</span>
          </div>
          <p className="f-desc">Building intelligent, AI-powered software solutions that transform how businesses operate across industries.</p>
        </div>

        <div className="f-col">
          <h4>Navigate</h4>
          <ul className="f-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="f-col f-contact">
          <h4>Contact Us</h4>
          <p><img src="/phone.png" alt="" />+91 8121325297</p>
          <p><img src="/email.png" alt="" />info@visiontechnoservices.com</p>
          <p><img src="/address.png" alt="" />314B, JPTS, Mallapur, Hyderabad</p>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Vision Techno Services. All rights reserved.</span>
      </div>
    </footer>
  );
}
